import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { Menu } from '../models/Menu'
import { VENUES_URL } from '../utils/urls'

const fetchMenus = (venueSlug: string, params: TableParams) =>
  SBAPI.FetchPaginated<Menu[]>(`${VENUES_URL}/${venueSlug}/menus`, params)

const createMenu = (venueSlug: string, menu: FormData) =>
  SBAPI.Post(`${VENUES_URL}/${venueSlug}/menus`, menu)

const updateMenu = (venueSlug: string, menu: FormData) =>
  SBAPI.Post(`${VENUES_URL}/${venueSlug}/menus/${menu.get('id')}`, menu)

const deleteMenu = (venueSlug: string, menu: Menu) =>
  SBAPI.Delete(`${VENUES_URL}/${venueSlug}/menus/${menu.id}`)

const reorderMenus = (
  venueSlug: string,
  orderData: { id: number; order: number }[]
) =>
  SBAPI.Post(`${VENUES_URL}/${venueSlug}/menus/reorder`, { menus: orderData })

export { createMenu, deleteMenu, fetchMenus, reorderMenus, updateMenu }
